import { render, staticRenderFns } from "./InventoryPanel.vue?vue&type=template&id=073842ce"
import script from "./InventoryPanel.vue?vue&type=script&lang=js"
export * from "./InventoryPanel.vue?vue&type=script&lang=js"
import style0 from "./InventoryPanel.vue?vue&type=style&index=0&id=073842ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports